// src/pages/Torneios.tsx
import React, { useEffect, useState } from "react";
import Menu from "../componets/Menu";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  getMenuCollapsedMemory,
  setMenuCollapsedmemory,
  getButtonCollapsedMemory,
  setButtonCollapsedmemory,
  getVersionApp,
} from "../data/memory";
import { useWindowSize } from "../componets/useWindowSize";
import { resetList } from "../data/resetList";
import { autoResetJogosMensal } from "../data/autoClear";
import AlertSuccess from "../componets/AlerSuccess";
import AlertError from "../componets/AlertError";
import {
  atualizarInscritosTorneio,
  cancelarInscricao,
  deletarTorneio,
  iniciarTorneio,
  listenTorneio,
} from "../data/torneioService";
import AlertPerigo from "../componets/AlertPerigo";
import { useNavigate } from "react-router-dom";
import { getAllUsers, getUserId } from "../data/userService";

interface UserOption {
  uid: string;
  nome: string;
}

const TorneioSuper12: React.FC = () => {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );
  const [inscritos, setInscritos] = useState<Record<string, any>>({});
  const [dataCriacao, setDataCriacao] = useState<number | null>(null);
  const [isMensalModalOpen, setIsMensalModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isCancelConfirmOpen, setIsCancelConfirmOpen] = useState(false);
  const [users, setUsers] = useState<UserOption[]>([]);
  const [successAlert, setSuccessAlert] = useState({
    open: false,
    message: "",
  });
  const [errorAlert, setErrorAlert] = useState({
    open: false,
    message: "",
  });

  const maxVagas = 12;

  useEffect(() => {
    resetList();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  useEffect(() => {
    const loadUsers = async () => {
      const allUsers = await getAllUsers();
      const mapped = Object.entries(allUsers || {})
        .filter(
          ([, user]: [string, any]) =>
            user?.bloq !== true && user?.level !== "dev"
        )
        .map(([uid, user]: [string, any]) => ({
          uid,
          nome: user?.displayName || "Usuária sem nome",
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setUsers(mapped);
    };

    loadUsers();
  }, []);

  useEffect(() => {
    const unsubscribe = listenTorneio((data) => {
      const existe = !!data?.criadoEm;
      setInscritos(data?.inscritos || {});
      setDataCriacao(data?.criadoEm || null);
      setLoading(false);

      const tipoTorneioAtivo = data?.tipo || "";

      if (!existe) {
        navigate("/torneios");
      } else if (tipoTorneioAtivo !== "super12") {
        // Redireciona para o torneio correto
        navigate(`/torneios/${tipoTorneioAtivo}`);
      } else if (data?.iniciado) {
        navigate("/torneios/jogos");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleMenuToggle = () => {
    const newCollapsed = !isMenuCollapsed;
    setIsMenuCollapsed(newCollapsed);
    setButtonCollapsedmemory(newCollapsed);
    setMenuCollapsedmemory(newCollapsed);
    setIsButtonCollapsed(!isButtonCollapsed);
  };

  const vagasRestantes = Math.max(0, maxVagas - Object.keys(inscritos).length);

  const handleToggleParticipant = async (
    uid: string,
    nome: string,
    isSelected: boolean
  ) => {
    if (!isSelected && Object.keys(inscritos).length >= maxVagas) {
      setErrorAlert({
        open: true,
        message: `Esse torneio aceita no máximo ${maxVagas} participantes.`,
      });
      return;
    }

    const updated = { ...inscritos };

    if (isSelected) {
      delete updated[uid];
    } else {
      updated[uid] = { nome };
    }

    await atualizarInscritosTorneio(updated);
  };

  const handleIniciar = async () => {
    try {
      await iniciarTorneio();
      // Navegação será feita no useEffect que escuta o Firebase
    } catch (err) {
      console.error("Erro ao iniciar torneio:", err);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      await deletarTorneio();
      setSuccessAlert({ open: true, message: "Torneio deletado com sucesso!" });
      setIsMensalModalOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <main className="flex h-dvh bg-pink-700">
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />
      <AlertError
        isOpen={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ open: false, message: "" })}
      />
      <AlertPerigo
        isOpen={isMensalModalOpen}
        onClose={() => setIsMensalModalOpen(false)}
        onConfirm={handleConfirmDelete}
        message="Você tem certeza que deseja deletar o torneio?"
      />
      <AlertPerigo
        isOpen={isCancelConfirmOpen}
        onClose={() => setIsCancelConfirmOpen(false)}
        onConfirm={async () => {
          try {
            await cancelarInscricao();
            setSuccessAlert({
              open: true,
              message: "Inscrição cancelada com sucesso!",
            });
          } catch (error) {
            console.error("Erro ao cancelar inscrição:", error);
          } finally {
            setIsCancelConfirmOpen(false);
          }
        }}
        message="Você tem certeza que deseja cancelar sua inscrição?"
      />

      <div
        className={`fixed top-0 left-0 h-full ${
          isMenuCollapsed ? "w-16" : "w-64"
        } bg-custom-pink text-white transition-width duration-300`}
      >
        <button className="p-4 text-white" onClick={handleMenuToggle}>
          {isMenuCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <Menu isCollapsed={isMenuCollapsed} />
      </div>

      <section
        className={`flex-1 min-h-screen p-4 sm:p-6 pt-4 pb-20 bg-white ${
          isMenuCollapsed ? "ml-16" : "ml-64"
        } transition-margin duration-300`}
      >
        {loading && (
          <div className="flex items-center justify-center mt-20 py-8">
            <div className="flex items-center space-x-2 animate-pulse">
              <div className="w-8 h-8 bg-pink-400 rounded-full"></div>
              <div className="w-8 h-8 bg-pink-500 rounded-full"></div>
              <div className="w-8 h-8 bg-pink-600 rounded-full"></div>
            </div>
          </div>
        )}

        {!loading && (
          <>
            <div className="bg-black rounded-lg text-white p-4 sm:p-8 mb-10 sm:mb-20">
              <h2 className="text-xl sm:text-2xl font-semibold mb-6 text-center sm:text-left">
                Torneio Super 12
              </h2>

              <div className="mt-6 bg-gray-900 rounded-lg p-4">
                <div className="mb-4 flex items-center justify-between gap-3">
                  <h3 className="font-semibold text-white">Participantes</h3>
                  <span className="rounded-full bg-pink-500/15 px-3 py-1 text-sm text-pink-200">
                    {vagasRestantes === 0
                      ? "Torneio completo"
                      : `${vagasRestantes} vaga${vagasRestantes === 1 ? "" : "s"} restante${vagasRestantes === 1 ? "" : "s"}`}
                  </span>
                </div>

                <div className="max-h-[420px] space-y-2 overflow-y-auto pr-1">
                  {users.map((user) => {
                    const isSelected = Boolean(inscritos[user.uid]);

                    return (
                      <label
                        key={user.uid}
                        className="flex items-center justify-between gap-3 rounded-2xl border border-white/8 bg-white/5 px-4 py-3"
                      >
                        <span className="truncate text-sm text-white">
                          {user.nome}
                        </span>
                        <button
                          type="button"
                          role="switch"
                          aria-checked={isSelected}
                          onClick={() =>
                            handleToggleParticipant(
                              user.uid,
                              user.nome,
                              isSelected
                            )
                          }
                          className={`relative h-7 w-12 rounded-full transition ${
                            isSelected ? "bg-pink-500" : "bg-zinc-600"
                          }`}
                        >
                          <span
                            className={`absolute top-1 h-5 w-5 rounded-full bg-white transition ${
                              isSelected ? "left-6" : "left-1"
                            }`}
                          />
                        </button>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => setIsMensalModalOpen(true)}
                  disabled={isDeleting}
                  className={`mt-4 text-sm py-2 px-4 rounded-lg shadow-md transition-colors ${
                    isDeleting
                      ? "bg-red-400 cursor-not-allowed"
                      : "bg-red-700 hover:bg-red-800 text-white"
                  }`}
                >
                  {isDeleting ? "Deletando..." : "Deletar Torneio"}
                </button>

                <button
                  onClick={handleIniciar}
                  disabled={
                    loading || Object.keys(inscritos).length !== maxVagas
                  }
                  className={`mt-4 text-sm font-semibold py-2 px-6 rounded-lg shadow-md transition-colors ${
                    Object.keys(inscritos).length === maxVagas && !loading
                      ? "bg-green-600 hover:bg-green-700 text-white cursor-pointer"
                      : "bg-gray-400 text-gray-700 cursor-not-allowed"
                  }`}
                >
                  {loading ? "Iniciando..." : "Iniciar Torneio"}
                </button>

                {Object.keys(inscritos).includes(getUserId() || "") && (
                  <button
                    onClick={() => setIsCancelConfirmOpen(true)}
                    className="mt-4 w-full sm:w-auto text-sm bg-gray-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-gray-700"
                  >
                    Cancelar Inscrição
                  </button>
                )}
              </div>

              {dataCriacao && (
                <span className="text-gray-400 text-xs sm:text-sm mt-10">
                  Criado em {new Date(dataCriacao).toLocaleDateString("pt-BR")}
                </span>
              )}
            </div>
            <div className="w-full mt-auto text-center py-6 flex flex-col items-center space-y-1">
              <span className="text-gray-400 text-xs sm:text-sm">
                Developed by Samuel Stork
              </span>
              <span className="text-gray-400 text-xs sm:text-sm">
                {getVersionApp()}
              </span>
            </div>
          </>
        )}
      </section>
    </main>
  );
};

export default TorneioSuper12;
